import { useFonts } from 'expo-font';
import {
  Inter_400Regular,
  Inter_500Medium,
  Inter_600SemiBold,
  Inter_700Bold,
} from '@expo-google-fonts/inter';
import { SourceCodePro_400Regular } from '@expo-google-fonts/source-code-pro';
import {
  Poppins_400Regular,
  Poppins_500Medium,
} from '@expo-google-fonts/poppins';

const FONTS = {
  Inter_400Regular,
  Inter_500Medium,
  Inter_600SemiBold,
  Inter_700Bold,
  SourceCodePro_400Regular,
  Poppins_400Regular,
  Poppins_500Medium,
};

export function useAppFonts() {
  const [fontsLoaded, fontError] = useFonts(FONTS);

  return {
    fontsLoaded,
    fontError,
  };
}
